/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiResponse1ProjectListResponse,
  ApiResponse1ProjectResponse,
  MicrosoftAspNetCoreMvcProblemDetails,
} from '../models/index';
import {
    ApiResponse1ProjectListResponseFromJSON,
    ApiResponse1ProjectListResponseToJSON,
    ApiResponse1ProjectResponseFromJSON,
    ApiResponse1ProjectResponseToJSON,
    MicrosoftAspNetCoreMvcProblemDetailsFromJSON,
    MicrosoftAspNetCoreMvcProblemDetailsToJSON,
} from '../models/index';

export interface ApiProjectAllGetRequest {
    scope?: ApiProjectAllGetScopeEnum;
}

export interface ApiProjectEditPostRequest {
    id?: number;
    organization?: string;
    name?: string;
    thumbnail?: Blob;
    share?: Array<string>;
}

export interface ApiProjectIdTogglePinPostRequest {
    id: number;
}

export interface ApiProjectPostRequest {
    scope?: ApiProjectPostScopeEnum;
    organization?: string;
    name?: string;
    thumbnail?: Blob;
    share?: Array<string>;
}

/**
 * 
 */
export class ProjectApi extends runtime.BaseAPI {

    /**
     * Bu endpoint tüm projectleri listeler. Admin ve SuperAdmin tüm projectleri görebilirken, normal kullanıcılar sadece kendileriyle paylaşılan projectleri görebilir.
     * Tüm projectleri listeler
     */
    async apiProjectAllGetRaw(requestParameters: ApiProjectAllGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1ProjectListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['scope'] != null) {
            queryParameters['scope'] = requestParameters['scope'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Project/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1ProjectListResponseFromJSON(jsonValue));
    }

    /**
     * Bu endpoint tüm projectleri listeler. Admin ve SuperAdmin tüm projectleri görebilirken, normal kullanıcılar sadece kendileriyle paylaşılan projectleri görebilir.
     * Tüm projectleri listeler
     */
    async apiProjectAllGet(requestParameters: ApiProjectAllGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1ProjectListResponse> {
        const response = await this.apiProjectAllGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * **Required Roles:** Admin, SuperAdmin  Bu endpoint bir project üzerinde düzenleme yapmanızı sağlar. Thumbnail yüklenebilir.
     * var olan bir project\'i düzenler
     */
    async apiProjectEditPostRaw(requestParameters: ApiProjectEditPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1ProjectResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['id'] != null) {
            formParams.append('Id', requestParameters['id'] as any);
        }

        if (requestParameters['organization'] != null) {
            formParams.append('Organization', requestParameters['organization'] as any);
        }

        if (requestParameters['name'] != null) {
            formParams.append('Name', requestParameters['name'] as any);
        }

        if (requestParameters['thumbnail'] != null) {
            formParams.append('Thumbnail', requestParameters['thumbnail'] as any);
        }

        if (requestParameters['share'] != null) {
            requestParameters['share'].forEach((element) => {
                formParams.append('Share', element as any);
            })
        }

        const response = await this.request({
            path: `/api/Project/edit`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1ProjectResponseFromJSON(jsonValue));
    }

    /**
     * **Required Roles:** Admin, SuperAdmin  Bu endpoint bir project üzerinde düzenleme yapmanızı sağlar. Thumbnail yüklenebilir.
     * var olan bir project\'i düzenler
     */
    async apiProjectEditPost(requestParameters: ApiProjectEditPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1ProjectResponse> {
        const response = await this.apiProjectEditPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * **Required Roles:** Admin, SuperAdmin  
     * Bir project\'in pin durumunu toggle eder.
     */
    async apiProjectIdTogglePinPostRaw(requestParameters: ApiProjectIdTogglePinPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1ProjectResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiProjectIdTogglePinPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Project/{id}/toggle-pin`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1ProjectResponseFromJSON(jsonValue));
    }

    /**
     * **Required Roles:** Admin, SuperAdmin  
     * Bir project\'in pin durumunu toggle eder.
     */
    async apiProjectIdTogglePinPost(requestParameters: ApiProjectIdTogglePinPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1ProjectResponse> {
        const response = await this.apiProjectIdTogglePinPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * **Required Roles:** Admin, SuperAdmin  Bu endpoint yeni bir project oluşturur. Thumbnail yüklenebilir.
     * Yeni bir project oluşturur
     */
    async apiProjectPostRaw(requestParameters: ApiProjectPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1ProjectResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['scope'] != null) {
            formParams.append('Scope', requestParameters['scope'] as any);
        }

        if (requestParameters['organization'] != null) {
            formParams.append('Organization', requestParameters['organization'] as any);
        }

        if (requestParameters['name'] != null) {
            formParams.append('Name', requestParameters['name'] as any);
        }

        if (requestParameters['thumbnail'] != null) {
            formParams.append('Thumbnail', requestParameters['thumbnail'] as any);
        }

        if (requestParameters['share'] != null) {
            requestParameters['share'].forEach((element) => {
                formParams.append('Share', element as any);
            })
        }

        const response = await this.request({
            path: `/api/Project`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1ProjectResponseFromJSON(jsonValue));
    }

    /**
     * **Required Roles:** Admin, SuperAdmin  Bu endpoint yeni bir project oluşturur. Thumbnail yüklenebilir.
     * Yeni bir project oluşturur
     */
    async apiProjectPost(requestParameters: ApiProjectPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1ProjectResponse> {
        const response = await this.apiProjectPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const ApiProjectAllGetScopeEnum = {
    Internal: 'Internal',
    External: 'External'
} as const;
export type ApiProjectAllGetScopeEnum = typeof ApiProjectAllGetScopeEnum[keyof typeof ApiProjectAllGetScopeEnum];
/**
 * @export
 */
export const ApiProjectPostScopeEnum = {
    Internal: 'Internal',
    External: 'External'
} as const;
export type ApiProjectPostScopeEnum = typeof ApiProjectPostScopeEnum[keyof typeof ApiProjectPostScopeEnum];
